export type TextDirection = "ltr" | "rtl";

const letterCharacterPattern = /\p{Letter}/u;
const rtlCharacterPattern = /[\p{Script=Arabic}\p{Script=Hebrew}]/u;

export function getContentDirection(
	value: string | null | undefined,
	fallback: TextDirection,
): TextDirection {
	for (const character of value || "") {
		if (!letterCharacterPattern.test(character)) continue;
		return rtlCharacterPattern.test(character) ? "rtl" : "ltr";
	}

	return fallback;
}

export function getContentFieldProps(
	value: string | null | undefined,
	fallback: TextDirection,
	extraClassName = "",
) {
	const dir = getContentDirection(value, fallback);

	return {
		dir,
		className:
			`${dir === "rtl" ? "text-right" : "text-left"} ${extraClassName}`.trim(),
	};
}
